import { DEV } from "solid-js"
import { Color, DoubleSide, MeshLambertMaterial } from "three"
import type { Engine } from "../../../../core/engine/Engine.type"
import { getWaterNormals1024TexturePromise } from "../textures/getWaterNormals1024TexturePromise"

export default function createWaterPlaneV7BasicLambertMaterial(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  engine: Engine,
): MeshLambertMaterial {
  const material = new MeshLambertMaterial({
    // vertexColors: true,
    color: new Color(0xaaaaff),
    // color: new Color(0x001e0f),
    // opacity: 0.1,
    opacity: 0.5,
    // opacity: 1.0,
    transparent: true,
  })

  // getWaterNormals1024Texture
  getWaterNormals1024TexturePromise().then((texture) => {
    material.normalMap = texture
    // material.normalScale.set(20.0, 20.0)
    // material.normalMapType = TangentSpaceNormalMap
    // // material.normalMapType = ObjectSpaceNormalMap
  })

  if (DEV) {
    material.side = DoubleSide
    // material.wireframe = true
    // material.opacity = 0
  }

  return material
}